import { useEffect, useRef, useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';

/** Source of truth for the disarm window; the CSS countdown reads it too. */
const DISARM_MS = 2600;

/** Two-step confirm for destructive actions (stop-all, member removal, deploy).
 *  Disarms itself so a stray first click can't sit primed indefinitely. */
export function DangerButton({
  onConfirm,
  children,
  confirmLabel = 'Confirm?',
  className = 'btn danger sm',
  disabled,
}: {
  onConfirm: () => void;
  children: ReactNode;
  confirmLabel?: string;
  className?: string;
  disabled?: boolean;
}) {
  const [armed, setArmed] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <button
      type="button"
      className={className}
      disabled={disabled}
      data-armed={armed}
      style={{ '--disarm-ms': `${DISARM_MS}ms` } as CSSProperties}
      onClick={(e) => {
        e.stopPropagation();
        if (armed) {
          clearTimeout(timer.current);
          setArmed(false);
          onConfirm();
          return;
        }
        setArmed(true);
        timer.current = setTimeout(() => setArmed(false), DISARM_MS);
      }}
    >
      {armed ? confirmLabel : children}
    </button>
  );
}
